import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { passAmlCheck } from "services";

export const PassAmlButton = observer(() => {
  const { actionModals, bidCard } = useStores();

  const approveAMLHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          buttonText="Разрешить"
          text="KYT риск по транзакции приемлем, разрешить сделку"
          successText="Пополнение одобрено"
          calledQuery={() => passAmlCheck({ id: bidCard.bid.id })}
          onSuccess={() => {
            setTimeout(() => bidCard.fetchCardById(bidCard.bid.id), 1500);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        title: "Одобрение пополнения",
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <CustomButton
      type="primary"
      onClick={approveAMLHandler}
      tooltip="KYT риск по транзакции приемлем, разрешить сделку"
    >
      Продолжить сделку
    </CustomButton>
  );
});
